export default class AssertionError {
  constructor({ message, actual, expected }) {
    this.message = message
    this.actual = actual
    this.expected = expected
  }
}
